import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Row, Col, Form, Button } from '@duxton-web/ui';
import HedwigWidget from 'omega-rtc/components/form/trident-campaigns/HedwigWidget';
import {
  ACTION_TYPE_TEXT,
  TYPE_TO_FIELD_HEADER,
  TYPE_TO_PAYLOAD_FIELD,
  BULK_ACTION_MAPPING,
} from 'components/journey-builder/utils/constants';
import { getTemplate } from 'actions/newTridentExtra';
import LaunchIcon from 'img/ucd_launch.svg';
import 'components/journey-builder/css/actionform.scss';

const USER_TYPE = 'passenger';

// Wrapping hedwig widget component for form-able component
const HedwigWidgetComponent = ({ value, onChange, onTemplateChange }) => {
  const handleTemplateSelect = template => {
    setTimeout(() => {
      onTemplateChange(template);
      onChange(template.templateName);
    }, 10);
  };
  return (
    <HedwigWidget
      targetUserType={USER_TYPE}
      actionType={'push,inbox,pushinbox,email'}
      templateName={value}
      onSelect={handleTemplateSelect}
      showMyTemplate={false}
    />
  );
};

const ActionForm = props => {
  const [node, setNode] = useState(props.node);

  useEffect(() => {}, [props.node]);

  useEffect(() => {
    const { form, templates } = props;
    const latestNode = form.current.getFieldValue(node.id);
    const templateID = _.get(
      latestNode,
      'data.meta.messagingPayload.templateID',
    );
    const template = templates[templateID];
    if (template !== undefined) {
      const payloadField = TYPE_TO_PAYLOAD_FIELD[template.templateType];
      setNode(prevState => ({
        ...prevState,
        data: {
          ...prevState.data,
          type: BULK_ACTION_MAPPING[template.templateType],
          meta: {
            ...prevState.data.meta,
            messagingPayload: {
              ...prevState.data.meta.messagingPayload,
              templateID,
              params: {
                ...prevState.data.meta.messagingPayload.params,
                en: {
                  ...prevState.data.meta.messagingPayload.params.en,
                  title: _.get(template.payloads.en.payload, payloadField),
                },
              },
            },
          },
        },
      }));
    }
  }, [props.fetchTemplateRequest]);

  // TODO: Retrieve template info before populating it
  const getEssentialInfo = () => {
    return (
      <div className="essentialInfo">
        <Row>
          <Button
            target="_blank"
            href={window.Grab.config.HEDWIG_DASH_URI}
            style={{ marginRight: 8 }}
            size="small"
          >
            Create new template <img src={LaunchIcon} alt="" />
          </Button>
        </Row>
        <br />
        <div className="categoryHeader">Type</div>
        <div className="categoryContent">
          {ACTION_TYPE_TEXT[node.data.type]}
        </div>
        <div className="categoryHeader">
          {TYPE_TO_FIELD_HEADER[node.data.type]}
        </div>
        <div className="categoryContent">
          {_.get(node, 'data.meta.messagingPayload.params.en.title')}
        </div>
        <Button
          target="_blank"
          href={`${
            window.Grab.config.HEDWIG_DASH_URI
          }/templates/create/pushinbox/?id=${_.get(
            node,
            'data.meta.messagingPayload.templateID',
          )}`}
          style={{ marginRight: 8 }}
          size="small"
        >
          More details <img src={LaunchIcon} alt="" />
        </Button>
        <br />
      </div>
    );
  };

  const onTemplateChange = template => {
    const { node, form, getTemplate } = props;
    form.current.setFieldValue(
      [node.id, 'data', 'meta', 'messagingPayload', 'templateID'],
      template.templateId,
    );
    form.current.setFieldValue(
      [node.id, 'data', 'type'],
      BULK_ACTION_MAPPING[template.templateType],
    );
    getTemplate(template.templateId);
  };

  return (
    <div className="jb-form-action">
      <Row>
        <Col span={24}>
          <Form.Item
            rules={[{ required: true, message: 'Please select template' }]}
            label="Hedwig template"
            name={[
              props.node.id,
              'data',
              'meta',
              'messagingPayload',
              'templateName',
            ]}
          >
            <HedwigWidgetComponent
              type={props.node.data.type}
              onTemplateChange={onTemplateChange}
            />
          </Form.Item>
        </Col>
      </Row>
      {getEssentialInfo()}
    </div>
  );
};

function mapStateToProps(state: StoreState) {
  return {
    templates: _.get(state, 'newTridents.templates', {}),
    fetchTemplateRequest: _.get(
      state.requests,
      'getTemplateTridentCampaignsRequest',
      {},
    ),
  };
}

const mapDispatchToProps = dispatch => ({
  getTemplate: templateID => {
    dispatch(getTemplate({ templateID }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionForm);
